// Nome da forma de pagamento exibido no card do pedido.
//
// Pedidos do iFood chegam com a forma genérica "Pedido iFood" em `payments`; a forma real vem
// em `paymentMethods` (descrição gravada como "MÉTODO / bandeira", ex.: "CREDIT / VISA").
// Quando há exatamente uma forma, mostramos ela no lugar da genérica.

const METODOS_IFOOD: Record<string, string> = {
    CREDIT: "Crédito",
    DEBIT: "Débito",
    CREDIT_DEBIT: "Crédito/Débito",
    MEAL_VOUCHER: "Vale-refeição",
    FOOD_VOUCHER: "Vale-alimentação",
    GIFT_CARD: "Vale-presente",
    DIGITAL_WALLET: "Carteira digital",
    PIX: "PIX",
    CASH: "Dinheiro",
    BANK_PAY: "Débito em conta",
    EXTERNAL: "Externo",
    OTHER: "Outro",
}

const capitalizar = (texto: string) =>
    texto === texto.toUpperCase() && texto.length > 3
        ? texto.charAt(0) + texto.slice(1).toLowerCase()
        : texto

const formatarDescricao = (descricao: string) => {
    const partes = descricao.split(" / ")
    if (partes.length !== 2) return descricao

    const [metodo, bandeira] = partes.map(p => p.trim())
    const nomeMetodo = METODOS_IFOOD[metodo.toUpperCase()]
    if (!nomeMetodo) return descricao

    const semBandeira = !bandeira || bandeira === "---" || bandeira.toLowerCase() === nomeMetodo.toLowerCase()
    return semBandeira ? nomeMetodo : `${nomeMetodo} - ${capitalizar(bandeira)}`
}

export function nomeFormaPagamentoPedido(pedido: any): string {
    const metodos = pedido?.paymentMethods
    if (Array.isArray(metodos) && metodos.length === 1 && metodos[0]?.name) {
        return formatarDescricao(metodos[0].name)
    }
    return pedido?.payments?.name || ""
}
